import { createContext } from 'react';
import { Participant } from 'twilio-video';

export type SelectedParticipantContextType = [Participant | null, (participant: Participant | null) => void];

export const SelectedParticipantContext = createContext<SelectedParticipantContextType | null>(null);
export const SelectedParticipantConsumer = SelectedParticipantContext.Consumer;
